










import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import OverlayScrollbars from "overlayscrollbars";
import { OverlayScrollbarsComponent } from "overlayscrollbars-vue";

@Component({
  components: {
    OverlayScrollbarsComponent,
  },
})
export default class Alert extends Vue {
  beforeDestroy() {
    const a: any = document.getElementById("scroll");
    const instance = OverlayScrollbars(a, {});
    instance.options("overflowBehavior.y", "scroll");
    instance.options("overflowBehavior.x", "scroll");
  }
  mounted() {
    const a: any = document.getElementById("scroll");
    const instance = OverlayScrollbars(a, {});
    instance.options("overflowBehavior.y", "hidden");
    instance.options("overflowBehavior.x", "hidden");
  }
}
